
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useStoryblokState } from '@storyblok/react'
import Layout from '@/app/common/components/Layout'
import StoryblokSeo from '@/app/common/components/StoryblokSeo/StoryblokSeo'
import BlogAllArticles from '@/blocks/BlogLandingPage/BlogAllArticlesPage'
import {
  StoryblokBlogLandingPageProps,
  createGetServerSidePropsForBlogPage,
} from '@/domains/blogs/createGetServerPropsForBlogPage'

export function BlogAllArticlesPage(props: StoryblokBlogLandingPageProps) {
  const story = useStoryblokState(props.story)
  if (!story) {
    throw new Error('Empty story!')
  }

  return (
    <Layout>
      <StoryblokSeo story={story} />
      <BlogAllArticles blok={story.content} articles={props.articles} />
    </Layout>
  )
}

 const _getServerSideProps =
  createGetServerSidePropsForBlogPage('allArticlesPage')

export default BlogAllArticlesPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/blog/all-articles',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  